import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    getAuthorizationAsync: [],
    authorization: ['permissions', 'chapa'],
    chapa: [''],
    cleanAuthorization : []
});

/**
 * Handlers
 */
const INITIAL_STATE = {
    chapa: '',
    permissions: [],
};

const getAuthorization = (state = INITIAL_STATE, action) => {
    const newState = { ...state };
    newState.authorization = action.payload;

    return newState.authorization;
};

const authorization = (state = INITIAL_STATE, action) => {
	return { ...state, permissions: action.permissions };
};

const cleanAuthorization = (state = INITIAL_STATE, action) => {
	return INITIAL_STATE
};

const setChapa = (state = INITIAL_STATE, action) => {
	return { ...state, chapa: action.chapa };
};

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.GET_AUTHORIZATION_ASYNC]: getAuthorization,
    [Types.AUTHORIZATION]: authorization,
    [Types.CHAPA]: setChapa,
    [Types.CLEAN_AUTHORIZATION]: cleanAuthorization
});
